export default __webpack_public_path__ + "static/media/ObesityInfog.0515778a.png";